import React from "react";

const marketplaceLabels = {
  ebay: "eBay",
  facebookMarketplace: "Facebook Marketplace",
  etsy: "Etsy",
  amazon: "Amazon",
};

const StorefrontHero = ({ config }) => {
  const marketplaces = Object.entries(config.marketplaceLinks || {})
    .filter(([, value]) => Boolean(value))
    .map(([key]) => ({ key, label: marketplaceLabels[key] || key }));

  const hasLogo = Boolean(config.branding?.logoUrl);

  return (
    <section className={`storefront-hero storefront-hero--${config.layout.heroStyle}`}>
      {/* LEFT: copy */}
      <div className="storefront-hero__content">
        <p className="storefront-hero__eyebrow">Marketplace storefront</p>
        <h1 className="storefront-hero__title">{config.displayName}</h1>
        <p className="storefront-hero__subtitle">
          Listings are mirrored from trusted marketplaces and refreshed automatically.
        </p>

        {marketplaces.length > 0 ? (
          <div className="storefront-hero__marketplaces">
            {marketplaces.map((marketplace) => (
              <span key={marketplace.key} className="storefront-pill">
                {marketplace.label}
              </span>
            ))}
          </div>
        ) : null}
      </div>

      {/* RIGHT: purchase flow + brand mark */}
      <div className="storefront-hero__panel storefront-hero__panel--brand">
        <div className="storefront-hero__panel-text">
          <p className="storefront-hero__panel-title">Purchase flow</p>
          <p className="storefront-hero__panel-body">
            {config.policies.disclaimer}
          </p>
        </div>

        {hasLogo ? (
          <div className="storefront-hero__brandmark">
            <img
              src={config.branding.logoUrl}
              alt={`${config.displayName} logo`}
              loading="lazy"
              decoding="async"
            />
          </div>
        ) : (
          <div className="storefront-hero__brandmark storefront-hero__brandmark--text">
            {config.displayName}
          </div>
        )}
      </div>
    </section>
  );
};

export default StorefrontHero;
